export default [
  {
    path: "/products-parent",
    name: "productParent",
    redirect: "/products",
    icon: "circle",
    meta: {
      title: "Products",
      parentMenu: true,
      ability: { action: "read", subject: "Products" },
    },
    children: [
      {
        path: "/products",
        name: "products",
        icon: "list",
        component: () => import("@/views/Products/ProductsList.vue"),
        meta: {
          title: "List",
          pageTitle: "Products List",
          ability: { action: "read", subject: "Products" },
        },
      },
      {
        path: "/products/transparency-codes",
        name: "products-transparency-codes",
        icon: "shield",
        component: () => import("@/views/Products/TransparencyCodes.vue"),
        meta: {
          title: "Transparency Codes",
          ability: { action: "read", subject: "ProductCodes" },
        },
      },
      {
        path: "/products/fbm-products",
        name: "fbm-products",
        icon: "shopping-cart",
        component: () => import("@/views/Products/FBMProducts.vue"),
        meta: {
          title: "FBM Products",
          ability: { action: "read", subject: "Products" },
        },
      },
    ],
  },
];
